import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import Whatsapp from '../Socialmedia/whatsapp';
import { Breadcrumb } from 'react-bootstrap';
import { Helmet } from 'react-helmet';

const Layout = () => {
  const location = useLocation();
  
  // Extract the path segments and get the current page
  const pathnames = location.pathname.split('/').filter(Boolean);
  const currentPage = pathnames.length > 0 ? pathnames[pathnames.length - 1] : 'Home';

  // Function to format the page title
  const formatTitle = (page) => {
    return page.charAt(0).toUpperCase() + page.slice(1);
  };

  // Dynamic title and description for SEO using React Helmet
  const pageTitle = `Dr. Swati Chavhan Vanjari - ${formatTitle(currentPage)}`;
  const pageDescription = `Explore the ${currentPage} page of Dr. Swati Chavhan Vanjari's website. Learn more about our services, treatments, and therapies.`;

  return (
    <div className="w-full">
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="google-site-verification" content="hDy2TyO5-XOsY-kqHa_AsfhwAKrzVrvGjXLKbQkdVlw" />
        <meta name="description" content={pageDescription} />
      </Helmet>

      <Header />

      {/* Main content wrapper */}
      <main>
        {/* Render breadcrumb only for pages other than 'Home' */}
        {currentPage !== 'Home' && (
          <div className="w-full mb-6">
            <Breadcrumb className="bg-info-subtle shadow-md py-3 px-4 w-full">
              <Breadcrumb.Item href='/'className="text-black-600 hover:text-black-800 font-semibold"> 
                Home
              </Breadcrumb.Item>
              <Breadcrumb.Item active className="font-semibold text-blue-600 hover:text-blue-800"> 
                {formatTitle(currentPage)}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        )}

        {/* Render the content of the current route */}
        <Outlet />
      </main>

      <Whatsapp />
      <Footer />
    </div>
  );
};

export default Layout;
